export default __webpack_public_path__ + "static/media/milestones_mentor.2eaa10ec.svg";